import React from 'react'
import { Link } from 'react-router-dom'
import '../components/page404.css'

const Page404 = () => {
  return (
    <div className='page'>
        <div className="page-left">
        <h1>Are you lost?</h1>
        <h3>It seems that you are lost. Don't worry, the sushi have found you. Click and return to our home.</h3>
        </div>
       <Link to='/'>
        <div className="button-container">
        <button className='home-button'>Home</button> 
        </div>
       </Link>
        <div className="page-right">
            <div className="sushiOne">
            <img src={require('../assets/sushi1.png')} alt="sushi" />
            </div>
            <div className="sushiTwo">
            <img src={require('../assets/sushi2.png')} alt="sushi" />
            </div>         
        </div>        
    </div>
  )
}

export default Page404